import { ContactInfo } from '@app/+about/shared/types/contact-info.type';
import { LocPosition } from '@app/+about/shared/types/lock-position.type';
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';
import { AccordionData } from '@app/shared/types/accordion-data.type';
import {
  COMPANY_EMAIL,
  COMPANY_EMAIL_MAILTO,
  COMPANY_PHONE_DISPLAY,
  COMPANY_PHONE_TEL,
  COMPANY_WHATSAPP_DISPLAY,
  COMPANY_WHATSAPP_LINK,
} from '@app/shared/constants/company-contact.const';

// tabs data
export const contactTabs: ISectionTab[] = [
  {
    tabTitle: 'aboutUs',
  },
  {
    tabTitle: 'FAQ',
  },
];

// company map location (Swan Buildings, Manchester)
export const companyLocation: LocPosition = {
  lat: 53.4853638,
  lng: -2.2333344,
};

// contact info
export const contactInfoData: ContactInfo[] = [
  {
    title: 'aboutUs.contactData.addressTitle',
    icon: 'map-1',
    description: 'aboutUs.contactData.addressValue',
  },
  {
    title: 'aboutUs.contactData.phoneNumber',
    icon: 'phone',
    description: COMPANY_PHONE_DISPLAY,
    href: COMPANY_PHONE_TEL,
    isNumberMode: true,
  },
  {
    title: 'aboutUs.contactData.whatsAppNumber',
    icon: 'phone',
    description: COMPANY_WHATSAPP_DISPLAY,
    href: COMPANY_WHATSAPP_LINK,
    isNumberMode: true,
  },
  // {
  //   title: 'aboutUs.contactData.fax',
  //   icon: 'phone',
  //   description: '09140761953',
  // },
  {
    title: 'aboutUs.contactData.email',
    icon: 'mail',
    description: COMPANY_EMAIL,
    href: COMPANY_EMAIL_MAILTO,
    descriptionClasses: '!lowercase',
  },
];

// contact faq
export const contactFAQ: AccordionData[] = [
  {
    _id: '0',
    question: 'aboutUs.faqData.item1.question',
    answer: 'aboutUs.faqData.item1.answer',
  },
  {
    _id: '1',
    question: 'aboutUs.faqData.item2.question',
    answer: 'aboutUs.faqData.item2.answer',
  },
  {
    _id: '2',
    question: 'aboutUs.faqData.item3.question',
    answer: 'aboutUs.faqData.item3.answer',
  },
  {
    _id: '3',
    question: 'aboutUs.faqData.item4.question',
    answer: 'aboutUs.faqData.item4.answer',
  },
  {
    _id: '4',
    question: 'aboutUs.faqData.item5.question',
    answer: 'aboutUs.faqData.item5.answer',
  },
];
